<template>
  <v-form>
    <v-layout>
      <v-flex xs8 ma-1>
        <v-text-field
          :placeholder="'Search for ' + searchScope"
          class="form-input"
          v-model="searchInput"
          label="Search"
          type="text"
          @change="searchItems"
        ></v-text-field>
      </v-flex>
      <v-flex xs4 ma-1>
        <v-select
          v-model="searchScope"
          :items="types"
          item-text="name"
          item-value="scope"
          v-if="!where"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-list two-line v-if="items.length > 0">
          <template v-for="(item, id) in items">
            <v-list-group :key="item._id" @click.stop="selectItem(item._id)">
              <v-list-item-content>
                <v-list-item-title>{{item._source.name}}</v-list-item-title>
                <v-list-item-subtitle
                  class="text--primary"
                >{{(item._source.group) ? '(' + item._source.group + ')' : ''}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ item._index }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-group>
            <v-divider v-if="id + 1 < items.length" :key="id"></v-divider>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<style lang="stylus"></style>
<script>
import fb from "@/firebase";
//import { mapState } from 'vuex'

export default {
  name: "MultipleSearch",
  props: {
    where: String
  },
  components: {},
  data: function() {
    return {
      searchInput: "",
      types: [
        {
          name: "All",
          scope: "_all"
        },
        { name: "Partners", scope: "partners" },
        { name: "Services", scope: "services" },
        { name: "Offers", scope: "offers" },
        { name: "Businesses", scope: "businesses" },
        { name: "Plans", scope: "plans" }
      ],
      items: [],
      searchId: null,
      results: {},
      searchScope: ""
    };
  },
  mounted: function() {
    if (!this.where) {
      this.searchScope = "_all";
    } else {
      this.searchScope = this.where;
    }
  },
  filters: {},
  computed: {},
  watch: {
    searchId(id) {
      //console.log(id);
      if (id) {
        fb.db
          .collection("search_items")
          .doc(id)
          .onSnapshot(doc => {
            if (doc.data() && doc.data().response && doc.data().response.hits) {
              this.items = doc.data().response.hits.hits;
              this.results = { error: false, message: "Yeah! found them" };
            } else {
              this.results = { error: true, message: "No results" };
            }
          });
      }
    }
  },
  methods: {
    selectItem(itemId) {
      //console.log("Emit", itemId);
      this.$emit("selected", itemId);
      //this.resetForm();
    },
    resetForm() {
      this.items = [];
      this.searchId = null;
      this.results = {};
      this.searchScope = "_all";
      this.searchInput = "";
    },
    searchItems(query) {
      //console.log(query);
      if (query.length >= 3) {
        const target = "*" + query + "*";
        let scope = this.searchScope;
        if (this.searchScope === "_all") {
          scope = "services,partners,businesses,plans,offers";
        }
        if (target && scope) {
          fb.db
            .collection("search_items")
            .add({
              request: {
                index: scope,
                type: scope,
                q: target // Shorthand query syntax
              },
              response: null
            })
            .then(docRef => {
              //console.log("Document written with ID: ", docRef.id);
              this.searchId = docRef.id;
            })
            .catch(() => {
              //console.error("Error adding document: ", error);
            });
        }
      } else {
        this.results = { error: true, message: "No results" };
        this.searchItems = [];
      }
    }
  }
};
</script>
